import apiClient from '@/services/api_client';

// `documentId` is set by the doc studio only: it is what tells the backend this is a
// document export and not a chat message exported to docx.
export async function exportMessage(
    tenantId: string,
    htmlContent: string,
    documentId?: string
): Promise<Blob> {
    const blob = await apiClient.post(
        '/html-to-docx',
        {
            html: htmlContent,
            tenant_id: tenantId,
            document_id: documentId
        },
        true
    );
    return blob;
}
